export const boards = [
    {
        "id": "9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
        "name": "Main",
        "color": "#d32f2f",
        "tags": ["tag 1", "tag 2"],
        "cards": [
        {
            "id": "1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4bed",
            "content": "Never gonna give you up",
            "status": "Todo",
            "tags": ["tag 1", "tag 2"]
        },
        {
            "id": "1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4bee",
            "content": "Never gonna let you down",
            "status": "Todo",
            "tags": ["tag 1"]
        },
        {
            "id": "1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4bef",
            "content": "Never gonna run around and desert you",
            "status": "Todo",
            "tags": ["tag 2"]
        },
        {
            "id": "1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4beg",
            "content": "Never gonna make you cry",
            "status": "Doing",
            "tags": []
        },
        {
            "id": "1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4beh",
            "content": "Never gonna say goodbye",
            "status": "Doing",
            "tags": ["tag 1"]
        },
        {
            "id": "1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4bei",
            "content": "Never gonna tell a lie and hurt you",
            "status": "Doing",
            "tags": ["tag 2"]
        },
        {
            "id": "1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4bej",
            "content": "We've known each other for so long. Your heart's been aching but you're too shy to say it.",
            "status": "Done",
            "tags": []
        },
        {
            "id": "1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4bek",
            "content": "Inside we both know what's been going on. We know the game and we're gonna play it.",
            "status": "Done",
            "tags": ["tag 2", "tag 1"]
        }
        ]
    },
    {
        "id": "9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6e",
        "name": "Board 2",
        "color": "#607d8b",
        "tags": [],
        "cards": [
        {
            "id": "1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4bea",
            "content": "Card 1",
            "status": "Todo",
            "tags": []
        },
        {
            "id": "1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4beb",
            "content": "Card 2",
            "status": "Todo",
            "tags": []
        },
        {
            "id": "1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4bec",
            "content": "Card 3",
            "status": "Doing",
            "tags": []
        }
        ]
    }
];